(function () {
  var serviceOrigin = "https://bloomingful-back-in-stock.onrender.com";
  var moneyFormatter = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" });

  function initialize() {
    var hub = document.querySelector("[data-bf-cone-look-hub]");
    var latest = document.querySelector("[data-bf-cone-latest]");
    if (hub) loadHub(hub);
    if (latest) loadLatest(latest);
  }

  async function loadHub(hub) {
    var apiBase = hub.dataset.apiBase || serviceOrigin;
    var code = new URLSearchParams(location.search).get("look") || new URLSearchParams(location.search).get("bf_cone_look") || "";
    try {
      var looks = await fetchLooks(apiBase, 12);
      var look = code ? looks.find(function (entry) { return entry.code === code.toUpperCase(); }) || await fetchLook(apiBase, code) : null;
      if (!look && code) {
        hub.querySelector("[data-bf-cone-loading]").hidden = true;
        hub.querySelector("[data-bf-cone-error-text]").textContent = "This Coneflower look is not available yet.";
        hub.querySelector("[data-bf-cone-error]").hidden = false;
        return;
      }
      if (!look) look = looks[0] || null;
      if (!look) {
        hub.querySelector("[data-bf-cone-loading]").hidden = true;
        hub.querySelector("[data-bf-cone-error-text]").textContent = "New Coneflower looks are coming soon.";
        hub.querySelector("[data-bf-cone-error]").hidden = false;
        return;
      }
      renderHub(hub, look, looks);
    } catch (error) {
      hub.querySelector("[data-bf-cone-loading]").hidden = true;
      hub.querySelector("[data-bf-cone-error]").hidden = false;
    }
  }

  async function loadLatest(section) {
    var apiBase = section.dataset.apiBase || serviceOrigin;
    try {
      var looks = await fetchLooks(apiBase, Number(section.dataset.limit || 6));
      if (!looks.length) return;
      section.querySelector("[data-bf-cone-latest-rail]").innerHTML = looks.map(lookTile).join("");
      section.hidden = false;
    } catch (_) {
      section.hidden = true;
    }
  }

  async function fetchLook(apiBase, code) {
    var response = await fetch(apiBase + "/api/coneflower-looks/" + encodeURIComponent(code), { mode: "cors", credentials: "omit" });
    if (response.status === 404) return null;
    var payload = await response.json();
    if (!response.ok || !payload.ok) throw new Error(payload.error || "Could not load look.");
    return payload.look;
  }

  async function fetchLooks(apiBase, limit) {
    var response = await fetch(apiBase + "/api/coneflower-looks?limit=" + encodeURIComponent(limit), { mode: "cors", credentials: "omit" });
    var payload = await response.json();
    if (!response.ok || !payload.ok) throw new Error(payload.error || "Could not load looks.");
    return payload.looks || [];
  }

  function renderHub(hub, look, looks) {
    document.title = look.title + " | Coneflower Designs x Bloomingful";
    hub._bfConeSnapshots = {};
    (look.featured_items || []).concat(
      look.shop_items || [],
      look.alternative_items || [],
      look.dried_preserved_alternative_items || []
    ).forEach(function (item) {
      if (item.snapshot?.product_id) hub._bfConeSnapshots[item.snapshot.product_id] = item.snapshot;
    });
    renderHero(hub.querySelector("[data-bf-cone-hero]"), look);
    var shop = mergeLookItems((look.featured_items || []).concat(look.shop_items || []));
    var shopWrap = hub.querySelector("[data-bf-cone-shop-wrap]");
    if (shop.length) {
      hub.querySelector("[data-bf-cone-shop]").innerHTML = shop.map(function (item) { return productCard(item, "shop"); }).join("");
      shopWrap.hidden = false;
    }
    renderGroupAction(hub, "shop", shop);
    var alternatives = (look.alternative_items || []).filter(relatedItemCanRender);
    var alternativesWrap = hub.querySelector("[data-bf-cone-alternatives-wrap]");
    if (alternatives.length) {
      hub.querySelector("[data-bf-cone-alternatives]").innerHTML = alternatives.map(function (item) { return productCard(item, "alternative"); }).join("");
      alternativesWrap.hidden = false;
    }
    var driedAlternatives = (look.dried_preserved_alternative_items || []).filter(relatedItemCanRender);
    var driedWrap = hub.querySelector("[data-bf-cone-dried-wrap]");
    if (driedAlternatives.length) {
      hub.querySelector("[data-bf-cone-dried]").innerHTML = driedAlternatives.map(function (item) { return productCard(item, "dried"); }).join("");
      driedWrap.hidden = false;
    }
    var more = looks.filter(function (entry) { return entry.code !== look.code; }).slice(0, 8);
    if (more.length) {
      hub.querySelector("[data-bf-cone-more]").innerHTML = more.map(lookTile).join("");
      hub.querySelector("[data-bf-cone-more-wrap]").hidden = false;
    }
    hub.querySelector("[data-bf-cone-loading]").hidden = true;
    hub.querySelector("[data-bf-cone-look-content]").hidden = false;
    hub.addEventListener("change", handleVariantChange);
    hub.addEventListener("click", handleHubClick);
    document.dispatchEvent(new CustomEvent("bloomingful:collection-hydrated", { detail: { container: hub } }));
  }

  function renderGroupAction(hub, kind, items) {
    var action = hub.querySelector('[data-bf-cone-add-all-wrap="' + kind + '"]');
    if (action && items.some(itemHasPurchasableVariant)) action.hidden = false;
  }

  function renderHero(target, look) {
    var image = look.cover_image_url
      ? '<div class="bf-cone-looks__hero-media"><img src="' + escapeHtml(look.cover_image_url) + '" alt="' + escapeHtml(look.title) + '" fetchpriority="high"></div>'
      : "";
    var date = look.post_date ? '<span>Originally shared ' + escapeHtml(formatDate(look.post_date)) + '</span>' : "";
    target.innerHTML = '<div class="bf-cone-looks__hero-inner page-width' + (image ? "" : " bf-cone-looks__hero-inner--no-image") + '">' + image +
      '<div class="bf-cone-looks__hero-copy"><p class="bf-cone-looks__eyebrow">Coneflower Designs x Bloomingful</p>' +
      '<h2>' + escapeHtml(look.title) + '</h2>' + (look.description ? '<p>' + escapeHtml(look.description) + '</p>' : "") +
      '<div class="bf-cone-looks__hero-actions">' + date + '</div></div></div>';
  }

  function productCard(item, kind) {
    var product = item.snapshot || {};
    var variants = product.variants || [];
    var selectedId = String(item.variant_id || (variants.length === 1 ? variants[0].id : ""));
    var selected = variants.find(function (variant) { return String(variant.id) === selectedId; }) || (variants.length === 1 ? variants[0] : null);
    var image = selected?.image_url || product.image_url || "";
    var available = product.status === "ACTIVE" && Boolean(selected?.available);
    var variantControl = variants.length > 1
      ? '<select class="bf-cone-look-card__variant" data-bf-cone-variant aria-label="Choose option"><option value="">Choose an option</option>' + variants.map(function (variant) {
          return '<option value="' + escapeHtml(variant.id) + '"' + (selectedId === String(variant.id) ? " selected" : "") + (variant.available ? "" : " disabled") + '>' + escapeHtml(variant.title + (variant.available ? "" : " - sold out")) + '</option>';
        }).join("") + '</select>'
      : "";
    var inactive = product.status !== "ACTIVE";
    var soldOut = !inactive && Boolean(selected) && !selected.available;
    var restockMessage = product.restock_date
      ? "Estimated restock " + formatDate(product.restock_date)
      : product.restock_window
        ? "Estimated restock " + product.restock_window
        : "";
    var action = available
      ? '<button class="btn" type="button" data-bf-cone-add data-variant-id="' + escapeHtml(selected.id) + '">Add to cart</button>'
      : '<a class="btn btn--secondary" href="' + escapeHtml(product.url || "#") + '">' + (inactive ? "View product" : soldOut ? "View sold-out product" : "Choose on product page") + '</a>';
    return '<article class="bf-cone-look-card grid-product" data-bf-cone-item data-kind="' + kind + '" data-product-id="' + escapeHtml(product.product_id || item.product_id) + '" data-product-handle="' + escapeHtml(product.handle || "") + '"' +
      ' data-bf-wsaio-variant-id="' + escapeHtml(selected?.id || "") + '" data-bf-wsaio-variant-sku="' + escapeHtml(selected?.sku || "") + '" data-bf-wsaio-variant-price="' + escapeHtml(moneyCents(selected?.price)) + '">' +
      '<a class="bf-cone-look-card__image" href="' + escapeHtml(product.url || "#") + '">' + (image ? '<img src="' + escapeHtml(image) + '" alt="' + escapeHtml(product.image_alt || product.title) + '" loading="lazy">' : "") +
      '<span class="bf-cone-look-card__badge">' + (kind === "shop" ? "Shop the Look" : kind === "dried" ? "Dried + Preserved Alternative" : "Alternative") + '</span></a>' +
      '<div class="bf-cone-look-card__body"><h3><a href="' + escapeHtml(product.url || "#") + '">' + escapeHtml(product.title || item.label || "Bloomingful floral") + '</a></h3>' +
      (item.label ? '<p class="bf-cone-look-card__label">' + escapeHtml(item.label) + '</p>' : "") +
      (item.note ? '<p class="bf-cone-look-card__note">' + escapeHtml(item.note) + '</p>' : "") +
      '<div class="grid-product__price">' + priceMarkup(selected || product) + '</div>' + variantControl +
      (inactive ? '<p class="bf-cone-look-card__unavailable">This product is no longer available.</p>' : soldOut ? '<p class="bf-cone-look-card__unavailable">' + escapeHtml(restockMessage || "Currently sold out.") + '</p>' : "") +
      '<div class="bf-cone-look-card__actions">' + action + '</div></div></article>';
  }

  function handleVariantChange(event) {
    if (!event.target.matches("[data-bf-cone-variant]")) return;
    var card = event.target.closest("[data-bf-cone-item]");
    var variantId = event.target.value;
    var snapshot = findRenderedSnapshot(card);
    var variant = (snapshot?.variants || []).find(function (entry) { return String(entry.id) === String(variantId); });
    var price = card.querySelector(".grid-product__price");
    var actions = card.querySelector(".bf-cone-look-card__actions");
    if (!variant) {
      actions.innerHTML = '<a class="btn btn--secondary" href="' + escapeHtml(snapshot?.url || "#") + '">Choose on product page</a>';
      return;
    }
    card.dataset.bfWsaioVariantId = variant.id;
    card.dataset.bfWsaioVariantSku = variant.sku || "";
    card.dataset.bfWsaioVariantPrice = moneyCents(variant.price);
    price.innerHTML = priceMarkup(variant);
    if (variant.image_url) card.querySelector(".bf-cone-look-card__image img").src = variant.image_url;
    actions.innerHTML = variant.available
      ? '<button class="btn" type="button" data-bf-cone-add data-variant-id="' + escapeHtml(variant.id) + '">Add to cart</button>'
      : '<a class="btn btn--secondary" href="' + escapeHtml(snapshot?.url || "#") + '">View product</a>';
    document.dispatchEvent(new CustomEvent("bloomingful:collection-hydrated", { detail: { container: card } }));
  }

  async function handleHubClick(event) {
    var addButton = event.target.closest("[data-bf-cone-add]");
    if (addButton) {
      event.preventDefault();
      await addItems([{ id: Number(addButton.dataset.variantId), quantity: 1 }], addButton);
      return;
    }
    var addAllButton = event.target.closest("[data-bf-cone-add-all]");
    if (!addAllButton) return;
    var hub = addAllButton.closest("[data-bf-cone-look-hub]");
    var kind = addAllButton.dataset.bfConeAddAll;
    var items = [...hub.querySelectorAll('[data-kind="' + kind + '"] [data-bf-cone-add]')].map(function (button) {
      return { id: Number(button.dataset.variantId), quantity: 1 };
    }).filter(function (item) { return item.id; });
    var status = hub.querySelector('[data-bf-cone-add-all-status="' + kind + '"]');
    if (!items.length) { status.textContent = "Choose any required options above first."; return; }
    await addItems(items, addAllButton, status);
  }

  async function addItems(items, button, statusTarget) {
    var original = button.textContent;
    button.disabled = true;
    button.textContent = "Adding...";
    try {
      var response = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: items }),
      });
      var payload = await response.json();
      if (!response.ok) throw new Error(payload.description || "Could not add that item.");
      button.textContent = "Added";
      if (statusTarget) statusTarget.innerHTML = 'Added to cart. <a href="/cart">View cart</a>.';
      document.dispatchEvent(new CustomEvent("cart:build"));
      document.dispatchEvent(new CustomEvent("cart:updated", { detail: { source: "coneflower-look" } }));
      setTimeout(function () { button.textContent = original; button.disabled = false; }, 1800);
    } catch (error) {
      button.textContent = original;
      button.disabled = false;
      if (statusTarget) statusTarget.textContent = error.message;
      else window.alert(error.message);
    }
  }

  function findRenderedSnapshot(card) {
    var productId = card?.dataset.productId;
    var hub = card?.closest("[data-bf-cone-look-hub]");
    return hub?._bfConeSnapshots?.[productId] || null;
  }

  function itemHasPurchasableVariant(item) {
    var product = item.snapshot || {};
    var variants = product.variants || [];
    if (variants.length === 1) return product.status === "ACTIVE" && variants[0].available;
    return Boolean(item.variant_id && variants.find(function (variant) { return String(variant.id) === String(item.variant_id) && variant.available; }));
  }

  function relatedItemCanRender(item) {
    var product = item.snapshot || {};
    if (product.status !== "ACTIVE") return false;
    return Boolean(product.available || (product.variants || []).some(function (variant) { return variant.available; }) || product.restock_date || product.restock_window);
  }

  function mergeLookItems(items) {
    var seen = {};
    return (items || []).filter(function (item) {
      var productId = String(item?.product_id || item?.snapshot?.product_id || "");
      if (!productId || seen[productId]) return false;
      seen[productId] = true;
      return true;
    });
  }

  function lookTile(look) {
    return '<a class="bf-cone-look-tile" href="' + escapeHtml(look.public_path) + '">' +
      (look.cover_image_url ? '<img src="' + escapeHtml(look.cover_image_url) + '" alt="' + escapeHtml(look.title) + '" loading="lazy">' : "") +
      '<span>' + escapeHtml(look.title) + '</span></a>';
  }

  function priceMarkup(value) {
    var price = Number(value?.price || 0);
    var compareAt = Number(value?.compare_at_price || 0);
    if (!price) return "";
    return (compareAt > price ? '<span class="grid-product__price--original">' + moneyFormatter.format(compareAt) + '</span> ' : "") +
      '<span>' + moneyFormatter.format(price) + '</span>';
  }

  function moneyCents(value) {
    return String(Math.round(Number(value || 0) * 100));
  }

  function formatDate(value) {
    var date = new Date(value + "T12:00:00");
    return Number.isNaN(date.getTime()) ? value : date.toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" });
  }

  function escapeHtml(value) {
    return String(value == null ? "" : value).replace(/[&<>"']/g, function (character) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[character];
    });
  }

  document.addEventListener("DOMContentLoaded", initialize);
})();
